import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, LANGS } from "./translations";
import { pageTranslations } from "./pageTranslations";

const LanguageContext = createContext(null);

// Merge page translations into the main translations dictionary
Object.keys(pageTranslations).forEach((code) => {
  if (translations[code]) Object.assign(translations[code], pageTranslations[code]);
});

const get = (obj, path) => path.split(".").reduce((a, k) => (a && a[k] !== undefined ? a[k] : undefined), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "fr";
    const stored = localStorage.getItem("hecnos_lang");
    if (stored && translations[stored]) return stored;
    const nav = (navigator.language || "fr").toLowerCase();
    if (nav.startsWith("en")) return "en";
    if (nav.startsWith("es")) return "es";
    if (nav.startsWith("zh")) return "zh";
    return "fr";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem("hecnos_lang", lang);
  }, [lang]);

  const setLang = useCallback((next) => {
    if (translations[next]) setLangState(next);
  }, []);

  const t = useCallback(
    (path, fallback = "") => {
      const v = get(translations[lang], path);
      if (v !== undefined) return v;
      const fr = get(translations.fr, path);
      return fr !== undefined ? fr : (fallback || path);
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useT = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used within LanguageProvider");
  return ctx;
};
